import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { environment } from "../../environments/environment";
import {
  setMobilePhoneMask as setMobilePhoneMaskUtil,
  chkLength as chkLengthUtil,
} from "../utils/format-util";
import { IMyDpOptions } from "mydatepicker";
import { DatePipe } from "@angular/common";
import { BsModalService } from "ngx-bootstrap/modal";
import { SupportService } from "../services/support-service";
import { Router } from "@angular/router";

@Component({
  selector: "app-patient-edit",
  templateUrl: "./patient-edit.component.html",
  styleUrls: ["./patient-edit.component.scss"],
})
export class PatientEditComponent implements OnInit {
  patientForm: FormGroup;
  patientinfosubmit = false;
  public myDatePickerOptions: IMyDpOptions = {};
  countryList: any = [];
  formValueChange = false;
  profileUpdateMessage = "";
  profileErrorMessage = "";
  stateList: any = [];
  patientDetails: any;
  basicinfotext: any = {};
  validationMessage: any = {};
  patientUpdate: string;
  checkinbutton = false;
  submitted = false;
  testCountryCode = "US";
  constructor(
    private appservice: AppService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private datepipe: DatePipe,
    private supportService: SupportService,
    private router: Router
  ) {
    this.myDatePickerOptions = {
      dateFormat: "mmm dd, yyyy",
      showClearDateBtn: false,
      editableDateField: true,
      firstDayOfWeek: "su",
      indicateInvalidDate: true,
    };
  }
  patientId: any;

  ngOnInit() {
    this.loadPatientForm();
    this.getcountry();
    this.getLanguage();
    this.patientId = sessionStorage.getItem("patientId");
    if (this.patientId) {
      this.getPatientInfoById();
    }
  }

  getcountry() {
    this.appservice.getCountry().subscribe(
      (res) => {
        if (res && res["entity"]) {
          this.countryList = res["entity"];
        } else {
          this.countryList = [];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  changeCountry(countryid) {
    if (countryid && (countryid === 101 || countryid === "101")) {
      this.patientForm.controls["patientzipmask"].setValue("000000");
      this.patientForm.controls.countrydialcode.setValue("+91");
    } else if (countryid && (countryid === 231 || countryid === "231")) {
      this.patientForm.controls["patientzipmask"].setValue("00000");
      this.patientForm.controls.countrydialcode.setValue("+1");
    }
    if (countryid) {
      this.patientForm.controls["patientState"].setValue("");
      this.getStateList(countryid);
    }
  }

  getStateList(countryid) {
    this.appservice.getState(countryid).subscribe(
      (res) => {
        this.stateList = [];
        if (res && res["entity"]) {
          this.stateList = res["entity"];
        }
      },
      (err) => {
        this.appservice.sessionOut(err);
      }
    );
  }

  setZipcodeMask(countryCode) {
    let mask = "";
    if (countryCode) {
      if (countryCode === 101 || countryCode === "101") {
        mask = "000000";
      } else if (countryCode === 231 || countryCode === "231") {
        mask = "00000";
      }
    }
    return mask;
  }

  getLanguage() {
    this.appservice.getlang().subscribe((res) => {
      if (res["validationMessage"] && res["basicInfo"]) {
        this.validationMessage = res["validationMessage"];
        this.basicinfotext = res["basicInfo"];
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.patientForm.valid) {
      this.submitinfo();
    } else {
      this.profileErrorMessage =
        "Please address the highlighted areas, then try again.";
      setTimeout(() => {
        this.profileErrorMessage = "";
      }, 5000);
    }
  }

  chkLength(data) {
    return chkLengthUtil(data);
  }

  changeMask(type, value) {
    if (type === "phonemask") {
      this.patientForm.controls.phonemask.setValue(
        this.setMobilePhoneMask(value)
      );
    }
  }

  getPatientInfoById() {
    const gender = null;
    this.appservice
      .getpatientbyid(this.patientId)
      .subscribe((patientInfo: any) => {
        if (patientInfo["status"]["status"] === 200) {
          this.patientDetails = patientInfo["entity"];
          if (this.patientDetails) {
            this.patientForm.controls.firstName.setValue(
              this.patientDetails.firstName
            );
            this.patientForm.controls.lastName.setValue(
              this.patientDetails.lastName
            );
            this.patientForm.controls.emailId.setValue(
              this.patientDetails.patientEmail
            );
            this.patientForm.controls.countrydialcode.setValue(
              this.patientDetails.patientPhoneCode
                ? this.patientDetails.patientPhoneCode
                : this.testCountryCode === "US"
                ? "+1"
                : "+91"
            );
            this.patientForm.controls.phonemask.setValue(
              this.setMobilePhoneMask(this.patientDetails.patientPhoneCode)
            );
            this.patientForm.controls.mobile.setValue(
              this.patientDetails.patientPhone
            );
            this.patientForm.controls.gender.setValue(
              this.patientDetails.gender
            );
            this.patientForm.controls.patientDob.setValue(
              this.setDateToDatePicker(this.patientDetails.dob)
            );

            if (this.patientDetails.address) {
              this.patientForm.controls.patientAddress1.setValue(
                this.patientDetails.address.addressLine1
              );
              this.patientForm.controls.patientAddress2.setValue(
                this.patientDetails.address.addressLine2
              );
              this.patientForm.controls.patientCity.setValue(
                this.patientDetails.address.cityName
              );
              this.patientForm.controls.patientZipCode.setValue(
                this.patientDetails.address.zipCode
              );
              if (this.patientDetails.address.country) {
                this.patientForm.controls.patientCountry.setValue(
                  this.patientDetails.address.country.id
                    ? this.patientDetails.address.country.id
                    : this.testCountryCode === "US"
                    ? 231
                    : 101
                );
                this.getStateList(this.patientDetails.address.country.id);
                this.patientForm.controls.patientzipmask.setValue(
                  this.setZipcodeMask(
                    this.patientForm.controls.patientCountry.value
                  )
                );
                if (this.patientDetails.address.state) {
                  this.patientForm.controls.patientState.setValue(
                    this.patientDetails.address.state.id
                      ? this.patientDetails.address.state.id
                      : ""
                  );
                }
              } else {
                this.patientForm.controls.patientzipmask.setValue("00000");
              }
            }
          }
        }
      });
  }

  submitinfo() {
    let dob = null;
    if (
      this.patientForm.controls["patientDob"]["value"] &&
      this.patientForm.controls["patientDob"]["value"].date
    ) {
      dob =
        this.patientForm.controls["patientDob"]["value"].date.year +
        "-" +
        this.patientForm.controls["patientDob"]["value"].date.month +
        "-" +
        this.patientForm.controls["patientDob"]["value"].date.day;
    }

    const data = {
      patientFirstName: this.patientForm.controls["firstName"].value,
      patientLastName: this.patientForm.controls["lastName"].value,
      patientEmail: this.patientForm.controls["emailId"].value,
      patientPhone: this.patientForm.controls["mobile"].value,
      patientPhoneCode: this.patientForm.controls["countrydialcode"].value,
      altPatientPhone: this.patientForm.controls["alternatemobile"].value,
      altPatientPhoneCode: this.patientForm.controls["alternateCountrydialcode"]
        .value,
      gender: this.patientForm.controls["gender"].value,
      dob: dob,
      patientId: this.patientId,
      address: {
        street: "",
        addressLine1: this.patientForm.controls["patientAddress1"].value,
        addressLine2: this.patientForm.controls["patientAddress2"].value,
        cityName: this.patientForm.controls["patientCity"].value,
        state: {
          id: this.patientForm.controls["patientState"].value,
        },
        country: {
          id: this.patientForm.controls["patientCountry"].value,
        },
        zipCode: this.patientForm.controls["patientZipCode"].value,
      },
    };
    this.appservice.addorupdatepatient(data).subscribe((res: any) => {
      if (res.status.status === 200) {
        if (res && res["status"] && res["status"]["status"] === 200) {
          this.formValueChange = false;
          this.profileUpdateMessage = this.basicinfotext.patientUpdate;
          setTimeout(() => {
            this.profileUpdateMessage = "";
          }, 5000);
        }
      }
    });
  }

  scrollTop(value) {
    document.getElementById(value).scrollIntoView({ behavior: "smooth" });
  }

  cancelModify() {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "patient-list",
    ]);
  }
  loadPatientForm() {
    this.patientForm = this.formBuilder.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      emailId: [
        "",
        [
          Validators.required,
          Validators.pattern(/^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/),
        ],
      ],
      countrydialcode: [""],
      mobile: ["", [Validators.required, Validators.minLength(10)]],
      phonemask: [""],
      patientDob: [{ date: null }],
      gender: [""],
      alternateCountrydialcode: [""],
      alternatemobile: ["", [Validators.minLength(10)]],
      alterphonemask: [""],
      patientState: [""],
      patientCountry: [""],
      patientCity: [""],
      patientAddress1: [""],
      patientAddress2: [""],
      patientZipCode: [""],
      patientzipmask: [""],
    });
  }

  setMobilePhoneMask(phoneCode) {
    return setMobilePhoneMaskUtil(phoneCode, this.testCountryCode);
  }

  setDateToDatePicker(dateStr) {
    const localdate = dateStr ? dateStr.toString().split("-") : null;
    if (localdate && localdate.length > 2) {
      return {
        date: { year: +localdate[0], month: +localdate[1], day: +localdate[2] },
      };
    } else {
      return { date: null };
    }
  }
}
